import React from "react";
import styles from "./Slide2.module.scss";
import { useIntl } from "react-intl";
import { messages } from "../../../Preparations.messages";
import * as appConfig from "appConfig";

export const Slide2: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <div className={styles.slide2}>
      <h2 className={styles.title}>{formatMessage(messages.softwareRequirementsSlide2Title)}</h2>
      <div className={styles.content}>
        <p>{formatMessage(messages.softwareRequirementsSlide2Description1)}</p>
        <div className={styles.imageContainer}>
          <img className={styles.image} src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/preparations/7.png`} />
        </div>
        <p>{formatMessage(messages.softwareRequirementsSlide2Description2)}</p>
      </div>
    </div>
  );
};
